import React from 'react';
import PropTypes from 'prop-types';
import AccordionBase from './AccordionBase';

class Accordion extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override AccordionBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Accordion> */
    className: PropTypes.string,
    /** Props to be applied to each section */
    sections: PropTypes.array.isRequired,
  };

  static defaultProps = {
    styleType: 'default',
  };

  getStyles = type => {
    switch (type) {
      case 'questionnaire':
        return {
          panelRoot: {
            boxShadow: '0 0 8px 0 rgba(0,0,0,0.12)',
            border: '1px solid #EAEAF2',
          },
          panelSummaryRoot: {
            height: '60px',
            '&$panelSummaryExpanded': {
              backgroundColor: '#FFF',
              borderBottom: `solid 1px #ECEBF0`,
            },
          },
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <AccordionBase styles={styles} {...otherProps} />;
  }
}

export default Accordion;
